import { render, staticRenderFns } from "./PopupComments.vue?vue&type=template&id=64972e04"
import script from "./PopupComments.vue?vue&type=script&lang=ts"
export * from "./PopupComments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports